module.exports = __webpack_public_path__ + "img/outlook_sync_updated.dbce40c2.png";